import React from 'react';
import { SubTitle, Description, Image } from '../../components/layouts';
import { buildImageURL } from '../../helpers';
import { AdLink } from './Link';
// import data from './ad.html';
import './style.scss';

const IMG = [
  buildImageURL('/ad-1.jpg'),
  buildImageURL('/ad-2.png'),
  buildImageURL('/ad-3.png'),
  buildImageURL('/ad-4.jpg'),
]

// export function Ad() {
//   return (
//     // <iframe srcDoc={data} />
//   )
// }

// export function Ad() {
//   return (
//     <div dangerouslySetInnerHTML={{__html: '<div>fafafa</div>'}}/>
//
//   )
// }

export function Ad() {
  return (
    <div className="page-section section-ad inverted">
      <div className="section-content">
        <div>
          <SubTitle>vivo WATCH</SubTitle>
          <AdLink bordered={false} href="https://shop.vivo.com.cn/product/10006210" text="购买我的X60 Pro+" />
          <Image className="img-1" src={IMG[0]}/>
        </div>
        <div>
          <SubTitle>Y系列</SubTitle>
          <AdLink bordered={false} href="https://shop.vivo.com.cn/product/10006210" text="机型对比" />
          <div>
            <SubTitle>Y52s</SubTitle>
            <AdLink bordered={false} href="https://shop.vivo.com.cn/product/10006210" text="机型对比" />
            <Image className="img-2" src={IMG[1]}/>
          </div>
          <div>
            <SubTitle>Y51s</SubTitle>
            <AdLink bordered={false} href="https://shop.vivo.com.cn/product/10006210" text="机型对比" />
            <Image className="img-3" src={IMG[2]}/>
          </div>
        </div>
        <div>
          <SubTitle>碎屏保</SubTitle>
          <AdLink bordered={false} href="https://shop.vivo.com.cn/product/10006210" text="立即选购" />
          <Image src={IMG[0]}/>
        </div>
      </div>
    </div>
  );
}
